// Canonical look for INFERRED geometry — surfaces the pipeline synthesized
// because the scan never captured them. Shared across the floorplan (2D
// canvas) and 3D renderers so the indication stays consistent, mirroring
// `demoedStyle.js`.
//
// Producers are open-loft reconstruction (`shared-lib/loft/`, see
// reference-docs/loft/overview.md) and stair-landing reconstruction
// (`shared-lib/split-level/reconstructLanding.js`), which between them emit:
//   - `category.railing` + `inferenceSource: 'loft-open-edge'` — a guard
//     along an edge where the floor plate ends at a void.
//   - `inferenceSource: 'story-inherited'` — a wall the scan missed upstairs,
//     projected up from the storey below.
//   - `floors[0].inferred` + `inferenceSource: 'loft-synthesis'` — the plate.
//   - `inferred` + `inferenceSource: 'stair-landing'` — a mid-flight landing
//     platform, appended after the room's own floor.
//
// Rake boundaries (`shared-lib/rake/`) produce the opposite of a synthesized
// wall: a polygon edge with NO wall record, where a roof plane descends to meet
// the floor. Nothing is added to draw, so nothing here changes — the edge draws
// like any other polygon edge, and the informational surface is the room
// panel's "sloped ceiling" badge, which reads `room.rakeEdges`.
//
// **Inferred geometry is no longer distinguished on the 2D canvas.** Walls used
// to take a dashed stroke in this colour; that was removed deliberately. What
// remains is the room-panel badge, which names the inference for a room whose
// FLOOR was synthesized. So the indication is informational, not visual: a
// reconstructed surface draws exactly like a scanned one.

/** Guard rail — a low wall over a void, not drywall. */
export const RAILING_COLOR = '#8C7B6B';
export const RAILING_COLOR_HEX = 0x8c7b6b;

/** Text + border colour for the room panel's "inferred" badge. */
export const INFERRED_STROKE_COLOR = '#7A6A58';

/** Background for that badge. Despite the name this is not a canvas fill: no
 *  hatch for synthesized plates was ever built, and the earlier comment
 *  claiming one described an intention rather than behaviour. */
export const INFERRED_FILL_COLOR = 'rgba(140, 123, 107, 0.14)';

/** True when a wall is a guard rail along an open edge. */
export function isRailingWall(wall) {
  return Boolean(wall?.category?.railing);
}

/** True when the pipeline synthesized this element rather than observing it. */
export function isInferredElement(element) {
  return element?.inferred === true;
}
